import {
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  FormGroup,
  Col,
  Input,
  Form,
  Label,
  InputGroup,
  InputGroupText
} from "reactstrap"
import { User, Mail, Smartphone } from "react-feather"
import { jwtDecode } from "jwt-decode"

const UserProfile = () => {
  // console.log(jwtDecode(localStorage.getItem("accessToken")))
  return (
    <Card style={{ border: "none", boxShadow: 'none', marginBottom: '16px' }}>
      <CardHeader className="card_header">
        <CardTitle tag='h4'>User Details</CardTitle>
      </CardHeader>
      <CardBody>
        <Form>
          <FormGroup row>
            <Label sm='3' for='nameIcons'>
              User Name
            </Label>
            <Col sm='9'>
              <InputGroup className='input-group-merge' >
                <InputGroupText id="userProfile">
                  <User size={15} />
                </InputGroupText>
                <Input
                  type='text'
                  name='name'
                  id='nameIcons'
                  placeholder='User Name'
                  disabled
                  value={jwtDecode(localStorage.getItem("accessToken")).userData.name}
                  className="fs-14"
                />
              </InputGroup>
            </Col>
          </FormGroup>

          <FormGroup row>
            <Label sm='3' for='EmailIcons'>
              Email
            </Label>
            <Col sm='9'>
              <InputGroup className='input-group-merge'>
                <InputGroupText id="userProfile">
                  <Mail size={15} />
                </InputGroupText>
                <Input
                  type='email'
                  name='Email'
                  id='EmailIcons'
                  placeholder='Email'
                  disabled
                  value={jwtDecode(localStorage.getItem("accessToken")).userData.email}
                  className="fs-14"
                />
              </InputGroup>
            </Col>
          </FormGroup>

          <FormGroup row>
            <Label sm='3' for='mobileIcons'>
              Mobile
            </Label>
            <Col sm='9'>
              <InputGroup className='input-group-merge'>
                <InputGroupText id="userProfile">
                  <Smartphone size={15} />
                </InputGroupText>
                <Input
                  type='text'
                  name='phone_number'
                  id='mobileIcons'
                  placeholder='Mobile'
                  disabled
                  value={jwtDecode(localStorage.getItem("accessToken")).userData.phone_number}
                  className="fs-14"
                />
              </InputGroup>
            </Col>
          </FormGroup>
        </Form>
      </CardBody>
    </Card>
  )
}
export default UserProfile
